export default __webpack_public_path__ + "static/assets/c385289b09544e8a7b41debde987404e.png";